module.exports = __webpack_public_path__ + "static/logo-31e08acda52c5e75e2ec5efb258db1dc.png";